import {VetClinicPetSpecies} from "./vet-clinic-pet-species.model";
import {Client} from "./client.model";
import {VetClinic, VImage} from "./vet-clinic.model";
import {WellnessPlanItem} from "./wellness-plan-item.model";
import {WellnessPlanVetineoVisitTypeBundle} from "./wellness-plan-vetineo-visit-type-bundle.model";

/**
 * Główny model definiujący szablon Planu Opieki (Abonamentu).
 * Stanowi ofertę, określając cenę, grupę docelową (wiek/gatunek),
 * zawartość pakietu (usługi i przedmioty) oraz treści marketingowe wyświetlane pacjentom.
 */
export class WellnessPlan {

  /** Globalnie unikalny identyfikator szablonu planu w bazie danych. */
  public uuid: string;
  public authorUUID: string;
  public editorUUID: string;
  public created: Date;
  public modified: Date;

  /** Nazwa handlowa pakietu. */
  public name: string;

  /** Opis planu opieki. */
  public description: string;

  /** Cena planu.
   */
  public price: number;

  /** Zniżka oferowana w ramach tego pakietu. */
  public discount: number;

  /** Opis zniżki dla pacjenta. */
  public discountDescription: string;

  /** Ograniczenie wiekowe (od)
   */
  public minAnimalAge: number;

  /** Ograniczenie wiekowe (do). */
  public maxAnimalAge: number;

  /** Identyfikator wymaganego gatunku. */
  public petSpeciesId: number;
  public petSpecies: VetClinicPetSpecies;

  /** Właściciel szablonu abonamentu (Klient).
   */
  public vClientId: number;
  public vClient: Client;

  /** Tablica klinik (oddziałów), w których ten konkretny plan jest dostępny.
   * Umożliwia wdrożenie planu tylko w wybranych placówkach.
   */
  public vetClinics: VetClinic[];

  /** Wykaz usług (wizyt, szczepień, badań) wchodzących w skład abonamentu. */
  public wellnessPlanVetineoVisitTypeBundles: WellnessPlanVetineoVisitTypeBundle[];

  /** Tablica zdefiniowanych benefitów wchodzących w skład
   * danego abonamentu. Każdy element precyzyjnie określa limit ilościowy
   * (np. 2 razy) oraz częstotliwość dla powiązanej usługi.
   */
  public wellnessPlanItems: WellnessPlanItem[];

  /** Zestaw grafik reklamowych używanych na karcie produktu w aplikacji mobilnej. */
  public firstImage: VImage;
  public firstImageUUID: string;
  public secondImage: VImage;
  public secondImageUUID: string;
  public thirdImage: VImage;
  public thirdImageUUID: string;

  /** Komunikat powitalny po udanym aktywowaniu abonamentu. */
  public welcomeText: string;

  /** Tekst wyświetlany w trakcie trwania abonamentu (np. zachęcający do umówienia kolejnej wizyty). */
  public inProgressText: string;

  /** Komunikat na zakończenie cyklu abonamentowego. */
  public completionText: string;

  /** Najczęściej zadawane pytania (FAQ) dotyczące tego konkretnego planu. */
  public faq: string;

  /** Regulamin prawny (Terms & Conditions) wymagający akceptacji przy zakupie. */
  public terms: string;

  /** Reguła rozliczeniowa: Czy aktywacja usług rozpoczyna się
   * natychmiast, czy dopiero od pierwszego dnia następnego miesiąca.
   */
  public startNextMonth: boolean;

}
